import { Badge } from '@optiaxiom/react';

import type { Notification } from '../../../types';
import { getCategory } from '../../../utils';

type CategoryCellProps = {
  notification: Notification;
};

export function CategoryCell({ notification }: CategoryCellProps) {
  return <Badge intent="neutral">{getCategory(notification.type)}</Badge>;
}
